import React from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useFetchSharedAccessLogsQuery } from '#store';

const SharedAccessLogsModal = ({ show, onHide, link }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dateFormat = currentLanguage === 'pl' ? 'DD.MM.YYYY HH:mm:ss' : 'MMM D, YYYY HH:mm:ss';

  const { data: logs = [], isLoading } = useFetchSharedAccessLogsQuery(
    { id: link?.id },
    { skip: !show || !link }
  );

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{t('shared-access.logs-title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className='text-center py-4'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : logs.length === 0 ? (
          <p className='text-muted text-center py-4'>{t('shared-access.logs-empty')}</p>
        ) : (
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>{t('shared-access.logs.date')}</th>
                <th>{t('shared-access.logs.ip-address')}</th>
                <th>{t('shared-access.logs.user-agent')}</th>
                <th>{t('shared-access.logs.resource')}</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{moment(log.created).format(dateFormat)}</td>
                  <td>{log.ip_address || '-'}</td>
                  <td className='small' title={log.user_agent}>
                    {log.user_agent ? (
                      log.user_agent.length > 50 ? (
                        <span>{log.user_agent.substring(0, 50)}...</span>
                      ) : (
                        <span>{log.user_agent}</span>
                      )
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>{log.accessed_resource || '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          {t('forms.close') || 'Close'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SharedAccessLogsModal;

